// ============================================================================
// PENDING BANNER - Shows count of pending entities with bulk action
// ============================================================================

import { Loader2 } from 'lucide-react'

interface PendingBannerProps {
  pendingCount: number
  onReviewAll: () => void
  isUpdating?: boolean
}

export function PendingBanner({
  pendingCount,
  onReviewAll,
  isUpdating = false,
}: PendingBannerProps) {
  if (pendingCount === 0) return null

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 bg-amber-50 border-b border-amber-200">
      {/* Count badge */}
      <div className="flex items-center justify-center w-5 h-5 bg-amber-400 text-white text-xs font-semibold rounded-full">
        {pendingCount > 9 ? '9+' : pendingCount}
      </div>

      {/* Text */}
      <div className="flex-1 text-xs text-warm-700">
        <strong className="text-amber-600">{pendingCount} new entit{pendingCount === 1 ? 'y' : 'ies'}</strong>{' '}
        extracted by AI
      </div>

      {/* Action button */}
      <button
        onClick={onReviewAll}
        disabled={isUpdating}
        className="px-2.5 py-1 text-xs font-medium border border-amber-400 text-amber-600 bg-white rounded hover:bg-amber-400 hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5"
      >
        {isUpdating ? (
          <>
            <Loader2 className="w-3 h-3 animate-spin" />
            <span>Updating...</span>
          </>
        ) : (
          <span>Confirm All</span>
        )}
      </button>
    </div>
  )
}

export default PendingBanner
